<template>
  <div class="feedback-list">
    <div v-if="!type" class="feedback-list__title ms-small-head">
      Текущие задачи
    </div>
    <inline-loader v-if="loading" :loading="loading" />
    <ul v-else-if="items.length" class="feedback-list__items">
      <card
        :padding="4"
        v-for="item in items"
        :key="item.id"
        class="feedback-list__item"
      >
        <div class="feedback-list__item-container">
          <div class="feedback-list__info">
            <div class="feedback-list__status">
              <tag :color="item.status_no === 1 ? 'orange' : 'green'">
                {{ item.status_no === 1 ? "Новая" : "Завершено" }}
              </tag>
            </div>
            <div class="feedback-list__main">
              <div class="feedback-list__text ms-text">
                {{ item.text }}
              </div>
              <div v-if="type" class="feedback-list__user ms-help">
                {{
                  type === "to_me"
                    ? `От: ${getUserName(item.author)}`
                    : `Выполняет: ${getUserName(item.performer)}`
                }}
              </div>
              <div class="feedback-list__subinfo ms-help">
                <template v-if="contract_id">
                  {{ getUserName(item.performer) }}
                </template>
                <template v-else>
                  <a
                    class="ms-link"
                    v-if="!!item.contract"
                    :href="getUrl(item.contract_id)"
                    target="_blank"
                  >
                    {{ item.contract.code }}
                  </a>
                  <span v-else>Проект удален</span>
                </template>
              </div>
            </div>
          </div>
          <div class="feedback-list__actions">
            <i-button
              v-if="availableToComplete(item)"
              type="primary"
              @click="changeStatus(item)"
            >
              {{ item.status_no === 0 ? "Вернуть в работу" : "Завершить" }}
            </i-button>
            <i-button
              v-if="availableToRemove(item)"
              type="error"
              @click="remove(item)"
              shape="circle"
              icon="md-trash"
            >
            </i-button>
          </div>
        </div>
      </card>
    </ul>
    <div v-else class="ms-nodata ms-help">Задачи отсутствуют</div>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'

const types = ['create', 'update', 'delete']

export default {
  components: {
    InlineLoader
  },
  props: {
    contract_id: {
      type: String
    },
    type: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      user_id: this.$store.state.auth.user.id,
      loading: false,
      items: []
    }
  },
  watch: {
    '$store.state.socket': {
      handler: function (val) {
        if (!this.contract_id) return
        if (!val.create && !val.update && !val.delete) return

        const { type } = this.$store.state.socket

        if (type === 'tasks') {
          this.getData(true)
        }

        setTimeout(() => this.$store.commit('CLEAR_SOCKET_STATE'), 1000)
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    async getData (noloading) {
      try {
        if (!noloading) this.loading = true

        let url = 'page/task'
        if (this.contract_id) url += `?contract_id=${this.contract_id}`
        else {
          url += `?${this.type === 'from_me' ? 'author_id' : 'performer_id'}=${
            this.user_id
          }`
        }

        const tasks = await this.$store.dispatch('GET_REQUEST', { url })
        this.items = tasks.sort((a, b) => b.status_no - a.status_no)

        const newTasks = tasks.filter((t) => t.status_no === 1)
        this.$store.commit('SET_TASKS_FLAG', {
          type: this.contract_id ? 'contractTasks' : 'myTasks',
          value: !!newTasks.length
        })

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    availableToComplete ({ performer_id, author }) {
      return performer_id === this.user_id || author.id === this.user_id
    },
    availableToRemove ({ author }) {
      return author.id === this.user_id
    },
    async changeStatus ({ id, status_no }) {
      try {
        const url = `page/task`
        const data = {
          id,
          status_no: status_no === 1 ? 0 : 1
        }

        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.getData(true)
      } catch (error) {
        console.log(error)
      }
    },
    async remove ({ id }) {
      try {
        const url = `page/task?id=${id}`

        await this.$store.dispatch('DELETE_REQUEST', { url })
        this.getData(true)
      } catch (error) {
        console.log(error)
      }
    },
    getUrl (id) {
      const route = this.$router.resolve({
        path: `/app/contracts/${id}`
      })

      return route.href
    },
    socketHandler ({ source_id }) {
      if (source_id === 'tasks') {
        this.getData()
      }
    },
    getUserName (user) {
      if (!user) return 'Пользователь удален'

      const { username, first_name, last_name } = user

      if (!first_name || !last_name) return username

      return `${first_name} ${last_name}`
    }
  },
  created () {
    this.getData()

    if (!this.contract_id) {
      types.forEach((type) => {
        this.$socket.on(`data.${type}`, this.socketHandler)
      })
    }
  },
  beforeDestroy () {
    types.forEach((type) =>
      this.$socket.off(`data.${type}`, this.socketHandler)
    )
  }
}
</script>

<style lang="less">
.feedback-list {
  &__status {
    margin-right: 8px;

    .ivu-tag {
      margin: 0;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
    }
  }

  &__title {
    margin-bottom: 8px;
  }

  &__item {
    &:not(:first-child) {
      margin-top: 8px;
    }

    &:hover {
      .feedback-list__actions {
        display: block;
      }
    }

    &-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__info {
    display: flex;
  }

  &__actions {
    display: none;
    margin-left: 16px;
    flex-shrink: 0;

    .ivu-btn {
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
  }
}
</style>
